import React, { useState } from "react";
import { CheckIcon, Loader2Icon, MailIcon, MapPinIcon, PhoneIcon } from "lucide-react";
import { Reveal } from "./Reveal";
type Status = "idle" | "loading" | "success" | "error";
export function Contact() {
  const [status, setStatus] = useState<Status>("idle");
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });
  const update = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(f => ({
    ...f,
    [key]: e.target.value
  }));
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name.trim() || !/^\S+@\S+\.\S+$/.test(form.email) || !form.message.trim()) {
      setStatus("error");
      return;
    }
    setStatus("loading");
    setTimeout(() => setStatus("success"), 900);
  };
  const field = "w-full border-b border-line bg-transparent py-4 text-cream placeholder:text-stone/70 focus:border-sage focus:outline-none transition-colors duration-150";
  return <section id="contact" className="bg-ink py-24 lg:py-36" data-id="element-69" data-mp="3jv2wt2bfng3z">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10" data-id="element-70" data-mp="3jxnx3mw31nzm">
        <Reveal className="lg:col-span-5" data-id="element-71" data-mp="3otw8cp75sx1i">
          <h2 className="font-display text-5xl leading-[1] text-cream sm:text-6xl lg:text-7xl" data-id="element-72" data-mp="3b3j53057q6ii">
            Parlons de <span className="italic text-sage" data-id="element-73" data-mp="3f4ctdumkhnbx">votre futur Bengal.</span>
          </h2>
          <ul className="mt-12 space-y-5 text-stone" data-id="element-74" data-mp="315d0ubvxooah">
            <li className="flex items-center gap-4" data-id="element-75" data-mp="313s5wl5pj3c3">
              <MapPinIcon className="h-4 w-4 text-sage" aria-hidden="true" data-id="element-76" data-mp="364pp912ge3f6" />
              Ardèche, à 1h30 de Lyon — visites sur rendez-vous
            </li>
            <li className="flex items-center gap-4" data-id="element-77" data-mp="2s6hxd7k9xsav">
              <MailIcon className="h-4 w-4 text-sage" aria-hidden="true" data-id="element-78" data-mp="2w71rs3dgqhtb" />
              <a href="mailto:contact@pardusdei.com" className="transition-colors duration-150 hover:text-cream" data-id="element-79" data-mp="qdblt37p106t">
                contact@pardusdei.com
              </a>
            </li>
            <li className="flex items-center gap-4" data-id="element-80" data-mp="23bkfasmc5h94">
              <PhoneIcon className="h-4 w-4 text-sage" aria-hidden="true" data-id="element-81" data-mp="23cdhrhe9hklg" />
              Sur demande, après premier échange
            </li>
          </ul>
        </Reveal>

        <Reveal className="lg:col-span-6 lg:col-start-7" delay={0.05} data-id="element-82" data-mp="1ua45alzfnh5f">
          {status === "success" ? <div className="flex h-full flex-col justify-center border-t border-line pt-10" role="status" data-id="element-83" data-mp="1pcuk5ij2trne">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage text-ink" data-id="element-84" data-mp="2m0s4vtlgkegz">
                <CheckIcon className="h-5 w-5" data-id="element-85" data-mp="2i1rrwrpnw61w" />
              </span>
              <h3 className="mt-6 font-display text-4xl text-cream" data-id="element-86" data-mp="2d98epvuvzcxm">Merci, {form.name.split(" ")[0]}.</h3>
              <p className="mt-3 max-w-md text-stone" data-id="element-87" data-mp="28bgkgv6rreq9">
                Votre message est bien parti. Nous vous répondons personnellement sous 48 heures.
              </p>
            </div> : <form onSubmit={submit} noValidate className="space-y-2" data-id="element-88" data-mp="30yb3roruo825">
              <label className="block" data-id="element-89" data-mp="38aqr0tn2q0c0">
                <span className="sr-only" data-id="element-90" data-mp="38bsejxla0fam">Nom</span>
                <input className={field} placeholder="Votre nom" value={form.name} onChange={update("name")} data-id="element-91" data-mp="3d9k44kyg7pbn" />
              </label>
              <label className="block" data-id="element-92" data-mp="3i7lpxdn9e2qt">
                <span className="sr-only" data-id="element-93" data-mp="3iarf0svw14mj">Email</span>
                <input type="email" className={field} placeholder="Votre email" value={form.email} onChange={update("email")} data-id="element-94" data-mp="3maiah9wd08xe" />
              </label>
              <label className="block" data-id="element-95" data-mp="p9i0bqiic2">
                <span className="sr-only" data-id="element-96" data-mp="4tidglzdpmn3">Message</span>
                <textarea rows={5} className={`${field} resize-none`} placeholder="Parlez-nous de votre foyer et du chaton que vous recherchez" value={form.message} onChange={update("message")} data-id="element-97" data-mp="4w4juiaj9w3q" />
              </label>
              {status === "error" && <p className="pt-2 text-sm text-[#e8a08a]" role="alert" data-id="element-98" data-mp="55hv75kmph0y">
                  Merci de renseigner votre nom, un email valide et votre message.
                </p>}
              <div className="pt-8" data-id="element-99" data-mp="evax1euyyhs0">
                <button type="submit" disabled={status === "loading"} className="inline-flex items-center gap-3 rounded-full bg-sage px-8 py-4 text-sm font-medium text-ink transition-colors duration-150 hover:bg-cream disabled:opacity-70" data-id="element-100" data-mp="eyqh6w3i2h0a">
                  {status === "loading" && <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-101" data-mp="3sc1wi8i4wrbm" />}
                  {status === "loading" ? "Envoi en cours" : "Envoyer le message"}
                </button>
              </div>
            </form>}
        </Reveal>
      </div>
    </section>;
}